import React, { useEffect, useRef } from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { useKeyboard } from '$hooks/events';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const HeaderDialog = ({
    isNavOpen,
    children,
    handleClose,
}) => {
    const dialogRef = useRef();
    const scrollElementRef = useRef();

    useKeyboard({
        'Escape': (event) => {
            // Prevent dialog's default behaviour
            event.preventDefault();

            if (isNavOpen) {
                handleClose();
            }
        }
    }, [isNavOpen]);

    useEffect(() => {
        // use close/showModal methods to trigger browser's toplayer/inert mode
        const dialogNode = dialogRef.current;
        const scrollElementNode = scrollElementRef.current;
        if (isNavOpen) {
            if (dialogNode && !dialogNode.open && scrollElementNode) {
                disableBodyScroll(scrollElementNode);
                dialogNode.showModal?.();
            }
        } else {
            if (dialogNode && dialogNode.open && scrollElementNode) {
                enableBodyScroll(scrollElementNode);
                dialogNode.close?.();
            }
        }
    }, [isNavOpen]);

    return (
        <dialog
            className={'dialog-reset'}
            onClick={handleClose}
            ref={dialogRef}>
            <div
                className={'overflow-y-scroll overflow-x-hidden no-scrollbar fixed top-0 bottom-0 left-0 h-dvh header-dialog bg-white '}
                /* `stopPropagation()` to not close dialog when dialog is clicked */
                onClick={(e) => e.stopPropagation()}
                ref={scrollElementRef}>
                <div className='relative h-full flex flex-col'>
                    {children}
                </div>
            </div>
        </dialog>
    );
};


/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default HeaderDialog;
